import { render, staticRenderFns } from "./CommonModals.vue?vue&type=template&id=08adafc3"
import script from "./CommonModals.vue?vue&type=script&lang=js"
export * from "./CommonModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports